export default "__VITE_ASSET__CV3$e6YA__"